import React from "react";
import { Button } from "antd";

interface Props {
    onReload: () => void;
}
const Index = ({ onReload }: Props) => {
    return (
        <Button icon="redo" onClick={onReload}>
            手动刷新
        </Button>
    );
};

export default Index;
